import React from "react";
import {
  PageContainer,
  PageContainerStickyMode,
} from "../../../../_shared/generics/page/components/PageContainer";
import {HEADER_Z_INDEX, PATH_Z_INDEX} from "../../../../_shared/styles";
import {GRANITE, WHITE} from "../../../../_shared/colors";
import {FilterDropdownDisplayType} from "../../../../_shared/catalog/filter/types";
import {SortDropdown} from "../Filters/SortDropdown/SortDropdown";
import {FiltersRow} from "../Filters/FiltersRow";
import styled from "styled-components";
import {CatalogPath} from "../CatalogPath";
import {useCatalogSession} from "../../../../_shared/hooks/useProductCatalog/useCatalogSession/useCatalogSession";
import {NatSize, StyleOption} from "../../../../_shared/generics/_shared";
import {store} from "../../../../../store";
import {hardResetFilters} from "../../../../_shared/slices/CatalogSlice/CatalogSessionSlice";
import {NatLink} from "../../../../_shared/generics/button";
import {useSelector} from "react-redux";
import {IStore} from "../../../../_shared/slices/types/Store";

export const FilterOrder = [
  FilterDropdownDisplayType.UnitPrice,
  FilterDropdownDisplayType.SquareFoot,
  FilterDropdownDisplayType.BedAndBath,
  FilterDropdownDisplayType.Toggles,
];
const FilterBarContainer = styled.div<{expand: boolean}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  ${(props) =>
    props.expand
      ? `
    height: 48px;
    width: 100%;
  `
      : `
    height: 32px;
    width: fit-content;
  `}
  border-radius: 10px;
`;
const FilterBarWrapper = styled.div`
  position: sticky;
  top: 0px;
  z-index: ${HEADER_Z_INDEX - 100};
  width: 100%;
  padding: 8px 0;
`;

// TODO Extract this to a separate component
export const Filters = (props: {
  filtersCountToDisplay?: number;
  RIGHT_ALIGN_LAST_FILTER?: boolean;
}) => {
  const {filters} = useCatalogSession();
  const columnCount = useSelector((state: IStore) => state.page.columnCount);
  const expandFilterContainer = columnCount <= 4;
  return (
    <FilterBarWrapper>
      <FilterBarContainer expand={expandFilterContainer}>
        <SortDropdown />
        <SortFilterDividerBreak />
        <FiltersRow
          filterTypes={FilterOrder}
          filtersCountToDisplay={props.filtersCountToDisplay}
          rightAlignLastFilter={props.RIGHT_ALIGN_LAST_FILTER}
        />
        <NatLink
          hidden={filters.length === 0 || expandFilterContainer}
          size={NatSize.SMALL}
          label={"Clear filters"}
          clickEvent={() => {
            store.dispatch(hardResetFilters());
          }}
          option={StyleOption.PRIMARY_LINK_ALT}
          style={{
            marginLeft: "16px",
            padding: "0 0",
            display: "flex",
            minWidth: "fit-content",
          }}
        />
      </FilterBarContainer>
    </FilterBarWrapper>
  );
};

export const MapCatalogBar = (props: {
  offset?: string;
  hideSort?: boolean;
  hideFilter?: boolean;
  isSticky?: boolean;
  filtersCountToDisplay?: number;
  RIGHT_ALIGN_LAST_FILTER?: boolean;
}) => {
  const {isSticky} = props;
  if (!isSticky) {
    return <CatalogPath showMainView={true} border={false} inventory={false} />;
  } else {
    return (
      <PageContainer
        backgroundColor={WHITE}
        stickyOptions={{
          offset: props.offset,
          mode: PageContainerStickyMode.MODAL,
          zIndex: PATH_Z_INDEX,
        }}
      >
        {!props.hideFilter && <Filters {...props} />}
      </PageContainer>
    );
  }
};

const SortFilterDividerBreak = styled.div`
  color: ${GRANITE};
  padding-left: ${(props) =>
    props.theme?.Filters?.gapBetweenFilters ?? "0.75rem"};
`;
